import { ThirdPartyPartnerDetails, ThirdPartyPartners } from 'models';
import DeliverooLogo from 'assets/images/graphic-deliveroo-logo.svg';

export const partnerDetails: Record<ThirdPartyPartners, ThirdPartyPartnerDetails> = {
  Deliveroo: {
    id: 'deliveroo',
    label: 'Deliveroo',
    url: 'https://deliveroo.co.uk/brands/zizzi',
    logo: DeliverooLogo,
  },
};
